import React from 'react';
import Navbar from '../../../components/Navbar';
import Header from '../../../components/Header';
import FormBuat from './Form';

const BuatKlaimKum = () => (
  <>
    <Navbar />
    <Header />
    <FormBuat />
  </>
);

export default BuatKlaimKum;
